import React from 'react'
import { Dialog, Slide, Box, Typography, Divider } from '@mui/material'
import { CustomButton } from 'components/CustomButton'
import { useTranslation } from 'react-i18next'

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} unmountOnExit />
})

export default function ModalMobile({
    children,
    open,
    closeByClick,
    maxWidth,
    className,
    headTitle,
    onExited,
    changeModal,
    sendSubmit,
    themeColor,
}) {
    const { t } = useTranslation()
    const accentColor = themeColor?.navigation?.buttons?.backgroundColor || '#eea236'

    return (
        <Dialog
            open={open}
            TransitionComponent={Transition}
            keepMounted
            className={className}
            onClose={closeByClick}
            onExited={onExited}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            sx={{
                backdropFilter: 'blur(2px)',
                '& .MuiDialog-paper': {
                    width: '100%',
                    maxWidth: maxWidth || '600px',
                    borderRadius: '12px',
                    boxShadow: '0px 8px 24px rgba(0,0,0,0.12)',
                    p: '20px',
                },
                '& .MuiDialog-scrollPaper': {
                    marginTop: '100px',
                    alignItems: 'flex-start',
                },
            }}
        >
            {changeModal ? (
                <Box display="flex" alignItems="center" gap="12px" mb="16px">
                    <Typography fontSize="14px" fontWeight={700} color="#21409A" whiteSpace="nowrap">
                        {t('Confirm_Mobile')}
                    </Typography>
                    <Divider sx={{ flex: 1, borderColor: '#21409A' }} />
                    <Box display="flex" gap="8px">
                        <CustomButton size="sm" variant="contained" defaultColor="#5CB860" onClick={sendSubmit}>
                            {t('BUTTON_CONFIRM')}
                        </CustomButton>
                        <CustomButton size="sm" variant="outlined" defaultColor="#aaa" onClick={closeByClick}>
                            {t('BUTTON_CANCEL')}
                        </CustomButton>
                    </Box>
                </Box>
            ) : (
                <Box display="flex" alignItems="center" gap="12px" mb="16px">
                    <Typography fontSize="14px" fontWeight={700} color={accentColor} whiteSpace="nowrap">
                        {t('Attention')}
                    </Typography>
                    <Divider sx={{ flex: 1, borderColor: accentColor }} />
                    <Box
                        component="span"
                        className="icon-ico_cancelar"
                        sx={{ fontSize: '20px', color: '#da3c3c', cursor: 'pointer' }}
                        onClick={closeByClick}
                    />
                </Box>
            )}

            <Box sx={{ fontSize: '14px', color: '#5D5D5D', lineHeight: 1.6 }}>
                {children}
            </Box>
        </Dialog>
    )
}
